<template>
  <div class="tooltip" :class="{ '--is-active': showToolTip }">
    <button
      @click="toggleToolTip"
      v-if="icon"
      class="+bare-button tooltip__icon +text-center +display-block"
      data-testcafe="tooltip-toggle"
    >
      i
    </button>
    <button
      @click="toggleToolTip"
      v-else
      class="bare-button +display-inline-block +cursor-pointer"
      data-testcafe="tooltip-toggle"
    >
      <slot name="trigger"></slot>
    </button>

    <transition name="fade">
      <div
        class="tooltip__box"
        :class="`--pos-${position}`"
        v-if="showToolTip"
        v-on-clickaway="closeToolTip"
        data-testcafe="tooltip-content"
      >
        <div class="tooltip__arrow-up"></div>
        <span class="tooltip__copy +fg-gray-dark +max-ch">
          <slot name="content"></slot>
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'cc-tooltip',
  mixins: [clickaway],
  props: {
    icon: { type: Boolean },
    position: { type: String }
  },
  data() {
    return {
      showToolTip: false
    }
  },
  methods: {
    toggleToolTip() {
      this.showToolTip = !this.showToolTip
    },
    closeToolTip() {
      this.showToolTip = false
    }
  }
}
</script>
<style scoped>
.bare-button {
  background: transparent;
  border: 0;
  margin: 0;
  padding: 0;
}
</style>
